import { NeutralDatePicker } from '../../forms/NeutralDatePicker';
import React from 'react';
import { showErrorInfo } from '../../forms/newFields';

export function PureDateField({ label, mandatory, meta, input, ...props }) {
  return (
    <div className="scope-field-container">
      <div className="scope-field-label">
        {label}
        {mandatory && ' *'}
      </div>
      <NeutralDatePicker meta={meta} input={input} {...props} />
      {showErrorInfo({ meta })}
    </div>
  );
}

